import React from 'react';
import UserAvatar from 'components/shared/UserAvatar';

const TeacherCard = ({ teacher, onSelect, showAvailabilityBadge = true, translations = {} }) => {
  return (
    <button
      onClick={onSelect}
      className="w-full bg-white rounded-lg shadow-sm border border-gray-200 p-4 text-left hover:shadow-md hover:border-blue-300 transition-all"
    >
      <div className="flex items-start gap-4">
        {/* Avatar */}
        <div className="flex-shrink-0">
          <UserAvatar
            src={teacher.avatar_url}
            name={teacher.name}
            size="lg"
          />
        </div>

        {/* Info */}
        <div className="flex-1 min-w-0">
          <h3 className="text-lg font-semibold text-gray-900 truncate">
            {teacher.name}
          </h3>
          {(teacher.headline || teacher.introduction) && (
            <p className="text-sm text-gray-600 mt-1 line-clamp-1">
              {teacher.headline || teacher.introduction}
            </p>
          )}
          {showAvailabilityBadge && (teacher.has_schedule ? (
            <span className="inline-flex items-center mt-2 text-xs text-green-600">
              <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              {translations.available || 'Available'}
            </span>
          ) : (
            <span className="inline-flex items-center mt-2 text-xs text-gray-400">
              <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
              </svg>
              {translations.not_available || 'Not Available'}
            </span>
          ))}
        </div>

        {/* Arrow */}
        <div className="flex-shrink-0 text-gray-400">
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </div>
      </div>
    </button>
  );
};

export default TeacherCard;
